import script from "./suoyou.vue?vue&type=script&setup=true&lang=js"
export * from "./suoyou.vue?vue&type=script&setup=true&lang=js"

import "./suoyou.vue?vue&type=style&index=0&id=cf4adfaa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf4adfaa"]])

export default __exports__